import React, { Component } from "react";
import { seccionesAyudaAcciones, tituloAyudaAcciones } from "./ayudaAccionesInformes";

class AyudaAccionesInformesModal extends Component {
  renderSeccion = (sec, idx) => (
    <section key={idx} className="ic-ayudaMenu-seccion">
      <h5>{sec.titulo}</h5>
      {(sec.parrafos || []).map((p, i) => (
        <p key={`p-${i}`}>{p}</p>
      ))}
      {Array.isArray(sec.lista) && sec.lista.length > 0 && (
        <ul>
          {sec.lista.map((item, i) => (
            <li key={`li-${i}`}>{item}</li>
          ))}
        </ul>
      )}
    </section>
  );

  render() {
    const { abierto, tipoInforme, onCerrar } = this.props;
    if (!abierto) return null;

    const secciones = seccionesAyudaAcciones(tipoInforme);
    const titulo = tituloAyudaAcciones(tipoInforme);

    return (
      <div className="ic-modalOverlay" onClick={onCerrar}>
        <div
          className="ic-modalCard ic-modalCard-ayuda ic-modalCard-ayudaMenu"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-labelledby="ic-ayuda-acciones-titulo"
        >
          <div className="ic-modalHeader">
            <h4 id="ic-ayuda-acciones-titulo">{titulo}</h4>
            <button type="button" className="boton" onClick={onCerrar}>
              Cerrar
            </button>
          </div>
          <div className="ic-ayudaMenu-body">
            {secciones.map(this.renderSeccion)}
          </div>
        </div>
      </div>
    );
  }
}

export default AyudaAccionesInformesModal;
